import { render, staticRenderFns } from "./materialSetting.vue?vue&type=template&id=1c8d9338&scoped=true&"
import script from "./materialSetting.vue?vue&type=script&lang=js&"
export * from "./materialSetting.vue?vue&type=script&lang=js&"
import style0 from "./materialSetting.vue?vue&type=style&index=0&id=1c8d9338&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c8d9338",
  null
  
)

export default component.exports